<div *ngIf="field.editable" [formGroup]="form">
  <label for="street">Street</label>
  <input
    id="street"
    class="form-control"
    type="text"
    [formControlName]="streetAlias"
    autocomplete="nope"
  />
  <input
    *ngIf="showStreet2"
    type="text"
    class="form-control street2"
    [formControlName]="street2Alias"
    autocomplete="nope"
  />
  <label for="city">City</label>
  <input
    id="city"
    class="form-control"
    type="text"
    [formControlName]="cityAlias"
    autocomplete="nope"
  />
  <div class="d-flex flex-row">
    <div class="flex-fill">
      <label for="state">State</label>
      <select id="state" class="form-control" [formControlName]="stateAlias">
        <option *ngFor="let option of stateOptions" [value]="option.value">{{ option.label }}</option>
      </select>
    </div>
    <div class="zip-container flex-fill">
      <label for="zip">Zip</label>
      <input
        id="zip"
        class="form-control"
        type="text"
        [textMask]="{mask: zipMask, guide: false}"
        [formControlName]="zipAlias"
        autocomplete="nope"
      />
    </div>
  </div>
</div>
<div *ngIf="!field.editable">
    <div>{{ streetValue }}</div>
    <div *ngIf="showStreet2">{{ street2Value }}</div>
    <div>{{ cityValue }}<span *ngIf="cityValue">,</span> {{ stateValue }} {{ zipValue }}</div>
</div>
